export default {
  PLANNED: 'PLANNED',
  ACTIVE: 'ACTIVE',
  STOPPING: 'STOPPING',
  STOPPED: 'STOPPED',
  ARCHIVED: 'ARCHIVED',
};
